export default "__VITE_PUBLIC_ASSET__c1346a5b__"